import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  menuInfo: {
    fontFamily: "Gilroy-ExtraBold, serif",
    color: "#000",
    fontSize: "1.5rem",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginTop: 25,
    marginBottom: 25,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  menus: {
    width: "90%",
    marginTop: 20,
    marginLeft: 30,
    marginBottom: 80,
    backgroundColor: "#FFFAF7",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: 0,
      marginLeft: 0,
    },
  },
  list: {
    width: "17%",
    height: 250,
    marginLeft: "1.5%",
    marginRight: "1.5%",
    marginTop: 20,
    marginBottom: 20,
  },
  button: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    fontSize: "14px",
    backgroundColor: "#e45826",
    color: "#fff",
    width: "160px",
    fontWeight: 400,
    height: 40,
    marginLeft: 5,
    marginRight: 5,
    "&:hover": {
      backgroundColor: "#e45826",
      boxShadow: "none",
    },
    [theme.breakpoints.down("sm")]: {
      width: "140px",
    },
    [theme.breakpoints.down("xs")]: {
      marginRight: 10,
      width: "140px",
    },
  },
  padding: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    alignItems: "space-between",
    padding: 30,
    [theme.breakpoints.down("sm")]: {
      padding: 5,
    },
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  clear: {
    borderRadius: "20px",
    fontFamily: "Gilroy-Light, serif",
    textTransform: "capitalize",
    fontSize: "1rem",
    border: "2px solid #e45826",
    backgroundColor: "#fff",
    color: "#e45826",
    width: "160px",
    fontWeight: 400,
    height: 40,
    marginLeft: 5,
    marginRight: 5,
    "&:hover": {
      backgroundColor: "#fff",
      boxShadow: "none",
    },
    [theme.breakpoints.down("sm")]: {
      width: "140px",
    },
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      width: "140px",
    },
  },
  alert: {
    marginTop: 20,
    marginBottom: 10,
  },
}));




